import RemoteSelect, { RemoteSelectProps } from 'common/components/RemoteSelect/RemoteSelect';
import { Establishment } from 'types/Establishment';

const processOptions = (options: Establishment[]) =>
  options.map(({ id, name }) => ({
    value: id,
    label: name,
  }));

export interface EstablishmentSelectProps extends RemoteSelectProps {
  excludeIds?: string[];
  filterOn?: Record<string, any>;
}

export function EstablishmentSelect({ excludeIds, filterOn, ...props }: EstablishmentSelectProps) {
  // Fonction pour traiter les tableaux et les transformer en paramètres indexés
  const processArrayValue = (baseName: string, arrayValue: any[]): { name: string; value: any }[] => {
    return arrayValue.map((value, index) => ({
      name: `${baseName}][${index}`,
      value,
    }));
  };

  const filters = [
    ...(excludeIds && excludeIds.length > 0
      ? processArrayValue('id][$notIn', excludeIds)
      : []),
    ...(filterOn
      ? Object.entries(filterOn).flatMap(([filterName, filterValues]) => {
        // Vérifier si filterValues est un objet (et pas null)
        if (filterValues && typeof filterValues === 'object' && !Array.isArray(filterValues)) {
          return Object.entries(filterValues).flatMap(([subFilterName, subFilterValues]) => {
            // Si la sous-valeur est un tableau, on le transforme en paramètres indexés
            if (Array.isArray(subFilterValues)) {
              return processArrayValue(`${filterName}][${subFilterName}`, subFilterValues);
            }
            // Sinon on retourne un filtre simple
            return [{
              name: `${filterName}][${subFilterName}`,
              value: subFilterValues,
            }];
          });
        }
        // Si filterValues est un tableau, on le transforme en paramètres indexés
        if (Array.isArray(filterValues)) {
          return processArrayValue(filterName, filterValues);
        }
        // Sinon on retourne un filtre simple
        return [{
          name: filterName,
          value: filterValues,
        }];
      })
      : []),
  ];
  const sort = 'name:asc';

  return (
    <RemoteSelect
      url="establishments"
      processOptions={processOptions}
      filters={filters}
      sort={sort}
      {...props}
    />
  );
}

export default EstablishmentSelect;
